import React, { Fragment } from 'react';
import { Star, ShieldCheck } from 'lucide-react';
import { UKFlag } from './UKFlag';
const AUDITORS = ['ISO 17025', 'UKAS', 'Eurofins UK', 'MHRA-licensed'];
export function TrustStrip() {
  return <section className="w-full bg-card border-y border-border" data-id="element-728">
      <div className="container mx-auto py-10 lg:py-12" data-id="element-729">
        <div className="grid grid-cols-1 lg:grid-cols-[auto_1fr_auto] gap-y-10 gap-x-12 items-center" data-id="element-730">
          {/* LEFT — Made in UK */}
          <div className="flex items-center gap-4" data-id="element-731">
            <div className="relative" data-id="element-732">
              <UKFlag size={56} rounded data-id="element-733" />
              <span className="absolute -bottom-1 -right-1 h-5 w-5 rounded-full bg-card border-2 border-card flex items-center justify-center" data-id="element-734">
                <ShieldCheck className="h-3.5 w-3.5 text-primary" strokeWidth={2} data-id="element-735" />
              </span>
            </div>
            <div data-id="element-736">
              <div className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium leading-none" data-id="element-737">
                Made in the UK
              </div>
              <div className="text-[16px] font-semibold tracking-tight text-foreground mt-1.5 leading-tight" data-id="element-738">
                Same-day cold-chain dispatch
              </div>
              <div className="text-[12.5px] text-muted-foreground mt-0.5" data-id="element-739">
                Tracked, discreet packaging
              </div>
            </div>
          </div>

          {/* MIDDLE — Lab auditors */}
          <div className="lg:border-x lg:border-border lg:px-12 py-2" data-id="element-740">
            <div className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mb-3" data-id="element-741">
              Independently verified by
            </div>
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2.5" data-id="element-742">
              {AUDITORS.map((a, i) => <Fragment key={a} data-id="element-743">
                  <span className="text-[14px] font-semibold tracking-tight text-foreground/85" data-id="element-744">
                    {a}
                  </span>
                  {i < AUDITORS.length - 1 && <span className="h-1 w-1 rounded-full bg-primary/60" aria-hidden data-id="element-745" />}
                </Fragment>)}
            </div>
            <div className="mt-4 pt-4 border-t border-border flex flex-wrap items-baseline gap-x-5 gap-y-1 text-[12.5px]" data-id="element-746">
              <span className="text-muted-foreground" data-id="element-747">
                <span className="font-semibold tracking-tight text-foreground [font-feature-settings:'tnum']" data-id="element-748">
                  99.8%
                </span>{' '}
                avg HPLC purity
              </span>
              <span className="h-1 w-1 rounded-full bg-primary/40" aria-hidden data-id="element-749" />
              <span className="text-muted-foreground" data-id="element-750">
                <span className="font-semibold tracking-tight text-foreground [font-feature-settings:'tnum']" data-id="element-751">
                  100%
                </span>{' '}
                batches tested
              </span>
              <span className="h-1 w-1 rounded-full bg-primary/40" aria-hidden data-id="element-752" />
              <span className="text-muted-foreground" data-id="element-753">
                <span className="font-semibold tracking-tight text-foreground [font-feature-settings:'tnum']" data-id="element-754">
                  30-day
                </span>{' '}
                guarantee
              </span>
            </div>
          </div>

          {/* RIGHT — Trustpilot */}
          <a href="#" className="group flex items-center gap-4 hover:opacity-90 transition-opacity" aria-label="View Trustpilot reviews" data-id="element-755">
            <div className="flex flex-col items-end" data-id="element-756">
              <div className="flex items-center gap-1" aria-hidden data-id="element-757">
                {Array.from({
                length: 5
              }).map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-primary text-primary" strokeWidth={0} data-id="element-758" />)}
              </div>
              <div className="flex items-baseline gap-1.5 mt-1.5" data-id="element-759">
                <span className="text-[24px] font-semibold tracking-[-0.02em] text-foreground leading-none [font-feature-settings:'tnum']" data-id="element-760">
                  4.8
                </span>
                <span className="text-[11px] text-muted-foreground leading-none" data-id="element-761">
                  / 5
                </span>
              </div>
              <div className="text-[11px] text-muted-foreground mt-1.5 leading-none" data-id="element-762">
                <span className="font-semibold text-foreground [font-feature-settings:'tnum']" data-id="element-763">
                  1,247
                </span>{' '}
                reviews on{' '}
                <span className="font-semibold text-foreground" data-id="element-764">
                  Trustpilot
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>;
}